import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-3 flex flex-wrap items-center gap-1 text-sm text-slate-500 dark:text-slate-400" data-testid="breadcrumbs">
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-slate-300 dark:text-slate-600" aria-hidden="true" />}
            {it.to && !isLast ? (
              <Link to={it.to} className="rounded hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring dark:hover:text-slate-200">{it.label}</Link>
            ) : (
              <span className="font-medium text-slate-700 dark:text-slate-300" aria-current={isLast ? "page" : undefined}>{it.label}</span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
